import { Global } from "./general";
const infoStorage = Global.infoStorage;
export default function headerRequest() {
  let user = JSON.parse(localStorage.getItem(infoStorage));
  if (user && user.token) {
    return { 'Authorization': "Bearer " + user.token };
  }
}